import { Language } from './types';

export enum DevLabelEnum {
  DEVELOPERS = 'developers',
  DEV_TITLE = 'devTitle',
  DEV_SUBTITLE = 'devSubTitle',
  DEV_SUBTITLE_TWO = 'devSubTitleTwo',
  DEV_SUBTITLE_THREE = 'devSubTitleThree',
  DEV_ADD = 'devAdd',
  DEV_ALIAS = 'devAlias',
  DEV_KEY_ID = 'devKeyId',
  DEV_KEY_SECRET = 'devKeySecret',
  DEV_KEY_CREATED = 'devKeyCreated',
  DEV_KEY_ACTION = 'devKeyAction',
  DEV_BTN_CREATE = 'devBtnCreate',
  DEV_CREATE_TITLE = 'devCreateTitle',
  DEV_DELETE_TITLE = 'devDeleteTitle',
  DEV_DELETE_SUBTITLE = 'devDeleteSubTitle',
}

const DEVELOPERS_TRANSLATIONS: Record<
  Language,
  Record<DevLabelEnum, string>
> = {
  EN: {
    [DevLabelEnum.DEVELOPERS]: 'Developers',
    [DevLabelEnum.DEV_TITLE]: 'Api Key',
    [DevLabelEnum.DEV_SUBTITLE]:
      'Your secret API keys are listed below. Please note that we do not display your secret API keys again after you generate them.',
    [DevLabelEnum.DEV_SUBTITLE_TWO]:
      'Do not share your API key with third parties, or expose it in browser or other client-side code.',
    [DevLabelEnum.DEV_SUBTITLE_THREE]:
      'Please keep this secret API keys somewhere safe and accessible. For security reasons, you will not be able to view it again through your account. If you lose this Keys, you will have to generate a new one.',
    [DevLabelEnum.DEV_ADD]: 'Add new keys',
    [DevLabelEnum.DEV_ALIAS]: 'Key Name',
    [DevLabelEnum.DEV_KEY_ID]: 'Client ID',
    [DevLabelEnum.DEV_KEY_SECRET]: 'Client Secrect',
    [DevLabelEnum.DEV_KEY_CREATED]: 'Date of Creation',
    [DevLabelEnum.DEV_KEY_ACTION]: 'Action',
    [DevLabelEnum.DEV_BTN_CREATE]: 'Create keys',
    [DevLabelEnum.DEV_CREATE_TITLE]: 'Create new API keys',
    [DevLabelEnum.DEV_DELETE_TITLE]: 'Delete Keys',
    [DevLabelEnum.DEV_DELETE_SUBTITLE]:
      'You are sure you want to delete the key: {{alias}} ?',
  },
  ES: {
    [DevLabelEnum.DEVELOPERS]: 'Desarrolladores',
    [DevLabelEnum.DEV_TITLE]: 'Claves API',
    [DevLabelEnum.DEV_SUBTITLE]:
      'A continuación se enumeran sus claves API. Tenga en cuenta que no volvemos a mostrar sus claves API después de que las genere.',
    [DevLabelEnum.DEV_SUBTITLE_TWO]:
      'No comparta su clave API con terceros, ni la exponga en el navegador o en otro código del lado del cliente.',
    [DevLabelEnum.DEV_SUBTITLE_THREE]:
      'Por favor, guarda estas claves secretas en algún lugar seguro y accesible. Por razones de seguridad, no podrás volver a verlas a través de tu cuenta . Si pierdes estas claves secretas, tendrás que generar unas nuevas.',
    [DevLabelEnum.DEV_ADD]: 'Nuevas claves',
    [DevLabelEnum.DEV_ALIAS]: 'Nombre de la Clave',
    [DevLabelEnum.DEV_KEY_ID]: 'Clave ID',
    [DevLabelEnum.DEV_KEY_SECRET]: 'Clave Secreta',
    [DevLabelEnum.DEV_KEY_CREATED]: 'Fecha de Creación',
    [DevLabelEnum.DEV_KEY_ACTION]: 'Acción',
    [DevLabelEnum.DEV_BTN_CREATE]: 'Crear Claves',
    [DevLabelEnum.DEV_CREATE_TITLE]: 'Crear nuevas Claves API',
    [DevLabelEnum.DEV_DELETE_TITLE]: 'Eliminar Claves',
    [DevLabelEnum.DEV_DELETE_SUBTITLE]:
      'Estas seguro que deseas eliminar la clave: {{alias}} ?',
  },
};

export default DEVELOPERS_TRANSLATIONS;
